import MainLayout from "../../layout";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import DeleteModal from "../../components/modal/delete-modal";
import { TextView } from "../../components/view-form-components/text-view";
import { useEffect } from "react";
import CommentsComponent from "../../components/comments/comments";
import FileCommentComponent from "../../components/comments/file-comment";
import { api } from "../../redux/apis/api";
import { useRole } from "../../context/role/RoleContext";
import { DocumentView } from "../../components/view-form-components/image.view";
import ShareModal from "../../components/modal/share-modal";

const ViewPayment = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { state } = useRole();
  const permission = state?.role?.payment;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [shareModalShow, setShareModalShow] = useState(false);

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/payment/view`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteFnc = (id) => {
    api
      .post(`/payment/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        navigate("/payment/list");
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  return (
    <MainLayout>
      <ShareModal
        isOpen={shareModalShow}
        onClose={() => {
          setShareModalShow(false);
        }}
        moduleName="payment"
        modulelabel="payment"
      />
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
        }}
        btnFnc={() => deleteFnc(params?.id)}
      />
      <section className="h-full overflow-auto px-3">
        <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
          <h2 className="text-xl font-semibold capitalize">payment - view</h2>
          <div className="flex gap-3 items-center">
            {permission?.write && (
              <button
                onClick={() => {
                  setShareModalShow(true);
                }}
                className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
              >
                share
              </button>
            )}
            {permission?.write && (
              <Link
                className="px-4 py-2 bg-blue-600 text-white rounded"
                to={`/payment/edit/${params?.id}`}
              >
                edit
              </Link>
            )}
            {permission?.write && (
              <button
                onClick={() => {
                  setdeleteModalShow(true);
                }}
                className="px-4 py-1 bg-errorColor border-[2px] border-errorColor text-white rounded"
              >
                Delete
              </button>
            )}
          </div>
        </div>
        <section className="w-full max-w-[40rem]">
          <div className="px-2">
            <TextView label={"Customer"} value={data?.customer_id ?? "--"} />
          </div>
          <div className="px-2">
            <TextView label={"order"} value={data?.order_id ?? "--"} />
          </div>
          <div className="px-2">
            <TextView label={"amount paid"} value={data?.amount_paid ?? "--"} />
          </div>
          <div className="px-2">
            <TextView
              label={"payment date"}
              value={data?.payment_date ?? "--"}
            />
          </div>
          <div className="px-2">
            <TextView
              label={"payment mode"}
              value={data?.payment_mode ?? "--"}
            />
          </div>
          <div className="px-2">
            <DocumentView
              label={"payment photo"}
              value={data?.payment_photo_url}
            />
          </div>

          <div className="px-2">
            <TextView label={"cheque date"} value={data?.cheque_date ?? "--"} />
          </div>
          <div className="px-2">
            <TextView label={"status"} value={data?.status ?? "--"} />
          </div>

          <div className="px-2">
            <TextView
              label={"transaction number"}
              value={data?.transaction_number ?? "--"}
            />
          </div>
          <div className="px-2">
            <TextView label={"refund_mode"} value={data?.refund_mode ?? "--"} />
          </div>
          <div className="px-2">
            <DocumentView
              label={"refund payment photo"}
              value={data?.refund_photo_url}
            />
          </div>
          <div className="px-2">
            <TextView label={"refund_upi"} value={data?.refund_upi ?? "--"} />
          </div>
          <div className="px-2">
            <TextView
              label={"refund_transaction_number"}
              value={data?.refund_transaction_number ?? "--"}
            />
          </div>
          <div className="px-2">
            <TextView
              label={"refund_account_number"}
              value={data?.refund_account_number ?? "--"}
            />
          </div>
          <div className="px-2">
            <TextView label={"refund_bank"} value={data?.refund_bank ?? "--"} />
          </div>
          <div className="px-2">
            <TextView label={"refund_ifsc"} value={data?.refund_ifsc ?? "--"} />
          </div>

          <CommentsComponent tableName={"payment"} viewId={params?.id} />
          <FileCommentComponent tableName={"payment"} viewId={params?.id} />
        </section>
      </section>
    </MainLayout>
  );
};

export default ViewPayment;
